import { render, staticRenderFns } from "./FolderView.vue?vue&type=template&id=989cae86&"
import script from "./FolderView.vue?vue&type=script&lang=js&"
export * from "./FolderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports